var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.114 14.556C11.6026 15.0432 12.3934 15.0432 12.882 14.556L22.568 4.87C22.7021 4.73637 22.7493 4.53844 22.6898 4.3587C22.6303 4.17895 22.4744 4.04823 22.287 4.021C22.192 4.007 22.0961 3.99998 22 4H2C1.90329 3.99988 1.80669 4.0069 1.711 4.021C1.52364 4.04823 1.36773 4.17895 1.30824 4.3587C1.24874 4.53844 1.29588 4.73637 1.43 4.87L11.114 14.556Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.888 5.83199C23.8196 5.80295 23.7405 5.81839 23.688 5.87099L17.488 12.071C17.3906 12.1689 17.3906 12.3271 17.488 12.425L22.531 17.468C22.7261 17.6562 22.8044 17.935 22.7359 18.1973C22.6673 18.4595 22.4627 18.6644 22.2005 18.7332C21.9383 18.8019 21.6594 18.7239 21.471 18.529L16.428 13.486C16.3811 13.439 16.3174 13.4125 16.251 13.4125C16.1846 13.4125 16.1209 13.439 16.074 13.486L13.945 15.615C12.8712 16.6882 11.1308 16.6882 10.057 15.615L7.926 13.488C7.82809 13.3906 7.66991 13.3906 7.572 13.488L2.529 18.531C2.23458 18.8151 1.7668 18.8108 1.47764 18.5214C1.18847 18.2319 1.18463 17.7641 1.469 17.47L6.512 12.427C6.60938 12.3291 6.60938 12.1709 6.512 12.073L0.312 5.87299C0.259817 5.81987 0.180316 5.80437 0.112 5.83399C0.0448452 5.86196 0.000801278 5.92724 0 5.99999V18C0 19.1046 0.89543 20 2 20H22C23.1046 20 24 19.1046 24 18V5.99999C24.0003 5.92643 23.956 5.86003 23.888 5.83199Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.cdf97240.svg";
export { ForwardRef as ReactComponent };